import React, {forwardRef} from 'react';

const ActiveRunIndicator = forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <div ref={ref} {...props}>
      <div className="ml-[6px] inline-block h-[6px] w-[6px] align-middle rounded-full bg-wb-success-text" />
    </div>
  );
});

export default ActiveRunIndicator;
